export function obterListaCteTipoServico() {
  return (
    [
      { label: '0 - Normal', value: 'NORMAL' },
      { label: '1 - Subcontração', value: 'SUBCONTRATACAO' },
      { label: '2 - Redespacho', value: 'REDESPACHO' },
      { label: '3 - Redespacho Intermediário', value: 'INTERMEDIARIO' },
      { label: '4 - Serviço Vinculado a Multimodal', value: 'MULTIMODAL' },
      { label: '6 - Transporte de Pessoas', value: 'PESSOAS' },
      { label: '7 - Transporte de Valores', value: 'VALORES' },
      { label: '8 - Transporte de Bagagem', value: 'BAGAGEM' },
    ]
  );
}
